import React from "react";
import * as SVG from "assets/iconsSVG";
import type { DataProps } from "screens/roletaAoVivo/interfaces";
import * as S from "./styles";

interface Props {
  data: DataProps;
}

const PDVInfo: React.FC<Props> = (props) => {
  return (
    <S.Container>
      <S.Badge>
        <SVG.BuildingRoletaIcon />
        <S.BadgeText>{props?.data?.nomePdv}</S.BadgeText>
      </S.Badge>
      <S.LargeText>Fila de atendimento</S.LargeText>
      <S.LightText>
        Turno: {"    "}
        <S.StrongText>{props?.data?.nomeTurno}</S.StrongText>
      </S.LightText>
    </S.Container>
  );
};

export default PDVInfo;
